import React, { useState } from "react";
import { Tabs } from "antd";
import {
  useExpenseCategoriesQuery,
  useExpenseSubcategoriesQuery,
  useCreateExpenseCategoryMutation,
  useUpdateExpenseCategoryMutation,
  useDeleteExpenseCategoryMutation,
  useCreateExpenseSubcategoryMutation,
  useUpdateExpenseSubcategoryMutation,
  useDeleteExpenseSubcategoryMutation,
} from "../../Services";
import { ExpenseSubCategory } from "./ExpensesSubCategory";
import { ExpenseCategory } from "./ExpensesCategory";
import { drawerTitle } from "../AppUi";
import { useIsMobile, useIsTablet } from "../../Hook";
import { ResizableDrawer } from "../ResizableDrawer/ResizableDrawer";

interface ManageExpenseCategoryDrawerProps {
  open: boolean;
  onClose: () => void;
}

export const ManageExpenseCategoryDrawer: React.FC<
  ManageExpenseCategoryDrawerProps
> = ({ open, onClose }) => {
  const [activeTab, setActiveTab] = useState("categories");
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();

  const { data: categories = [], isFetching: loadingCats } =
    useExpenseCategoriesQuery({ page: 1, limit: 100 }, { enabled: open });

  const { data: subcategories = [], isFetching: loadingSubs } =
    useExpenseSubcategoriesQuery({ page: 1, limit: 100 }, { enabled: open });

  const createCat = useCreateExpenseCategoryMutation();
  const updateCat = useUpdateExpenseCategoryMutation();
  const deleteCat = useDeleteExpenseCategoryMutation();
  const createSub = useCreateExpenseSubcategoryMutation();
  const updateSub = useUpdateExpenseSubcategoryMutation();
  const deleteSub = useDeleteExpenseSubcategoryMutation();

  return (
    <ResizableDrawer
      title={drawerTitle(
        "Manage Expenses",
        "Manage expense categories and subcategories",
      )}
      open={open}
      onClose={onClose}
      width={isMobile || isTablet ? "100%" : 580}
      destroyOnClose
      placement="right"
    >
      <Tabs
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key)}
        items={[
          {
            key: "categories",
            label: "Categories",
            children: (
              <ExpenseCategory
                categories={categories}
                loadingCats={loadingCats}
                createCat={createCat}
                updateCat={updateCat}
                deleteCat={deleteCat}
              />
            ),
          },
          {
            key: "subcategories",
            label: "Subcategories",
            children: (
              <ExpenseSubCategory
                categories={categories}
                subcategories={subcategories}
                loadingSubs={loadingSubs}
                createSub={createSub}
                updateSub={updateSub}
                deleteSub={deleteSub}
              />
            ),
          },
        ]}
      />
    </ResizableDrawer>
  );
};
